import { render, staticRenderFns } from "./SchoolListExportsIndex.vue?vue&type=template&id=0c9a952e"
import script from "./SchoolListExportsIndex.vue?vue&type=script&lang=js"
export * from "./SchoolListExportsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports